// Blog posts data - Fetched from Medium @samueladesola

export const blogPosts = [
  {
    id: 1,
    title: "Read Ultrasonic Sensor on Raspberry Pi using ROS2, display the data on a Qt GUI window",
    excerpt: "A very simple project — at least to see ROS2 in actual action. It can be a first step away from the simulation-based common ROS2 classes. In this guide, we will be reading an ultrasonic sensor connected to a Raspberry Pi using ROS2 and then sending the values to the development computer.",
    date: "December 23, 2025",
    readTime: "12 min read",
    mediumUrl: "https://samueladesola.medium.com/read-ultrasonic-sensor-on-raspberry-pi-using-ros2-display-the-data-on-a-qt-gui-window-48099271720c",
    tags: ["ROS2", "Python", "C#", "Qt", "Robotics"],
    coverImage: "https://cdn-images-1.medium.com/max/1024/1*G5yvY73m9hAM4NqzomY3gw.jpeg",
  },
  {
    id: 2,
    title: "Ubuntu Freezes While Running Blender Solved",
    excerpt: "I was surprised when I started experiencing freezing while using Blender on Ubuntu 22.04. The freezing only occurs while in layout mode. Here's how I solved it by fixing the NVIDIA driver.",
    date: "October 18, 2025",
    readTime: "5 min read",
    mediumUrl: "https://samueladesola.medium.com/ubuntu-freezes-while-running-blender-solved-3796ab87181e",
    tags: ["Blender", "Ubuntu"],
    coverImage: "https://cdn-images-1.medium.com/max/1024/0*QSRApTNDc_aP8qrV",
  },
  {
    id: 3,
    title: "How to install OpenCV on Ubuntu Server on Raspberry Pi 4",
    excerpt: "To need Ubuntu server and to need OpenCV, I believe the basic concepts of flashing an Ubuntu image on a Raspberry Pi are no longer an issue. Here's a quick guide to get OpenCV running on your Pi.",
    date: "July 10, 2025",
    readTime: "4 min read",
    mediumUrl: "https://samueladesola.medium.com/how-to-install-opencv-on-ubuntu-server-on-raspberry-pi-4-629f3f03d575",
    tags: ["Ubuntu Server", "OpenCV", "Raspberry Pi"],
    coverImage: "https://cdn-images-1.medium.com/max/1024/1*P0n7SOZBC6wQc7yj4e-Sfw.jpeg",
  },
  {
    id: 4,
    title: "A note about my internship journey",
    excerpt: "I guess we all believe that whenever you see the mail headline, \"Thank you for…\", we already know it is rejection. I think as of now, I've seen almost all ways rejection emails can be crafted. Anyway, I know I just need to win once.",
    date: "December 22, 2024",
    readTime: "2 min read",
    mediumUrl: "https://samueladesola.medium.com/a-note-about-my-internship-journey-7691cee153bf",
    tags: ["Internships"],
    coverImage: "https://cdn-images-1.medium.com/max/1024/0*fLTUszsBKJlmSx6h",
  },
  {
    id: 5,
    title: "Object Classification on Arduino Nano 33 BLE Sense Using Teachable Machine",
    excerpt: "I hope you haven't struggled a lot to get your model trained on Google Teachable Machine to be uploaded on Arduino Nano 33 BLE Sense. Everything will be well explained and solved in this guide, including the linker script error.",
    date: "August 8, 2024",
    readTime: "15 min read",
    mediumUrl: "https://samueladesola.medium.com/object-classification-on-arduino-nano-33-ble-sense-using-teachable-machine-3ead7389000a",
    tags: ["Arduino", "TensorFlow Lite", "Machine Learning", "TinyML", "Teachable Machine"],
    coverImage: "https://cdn-images-1.medium.com/max/1024/1*uKLEQSdqtL6KNS_EsOajvQ.png",
  },
  {
    id: 6,
    title: "How to control the P1 and P0 port pins of Arduino Nano 33 BLE Sense",
    excerpt: "Traditional Arduino boards are laid out regarding the pin numbering, but when the Arduino Nano 33 BLE Sense came, a few things changed. Here's how to properly address GPIO pins on both Port 0 and Port 1.",
    date: "May 23, 2024",
    readTime: "5 min read",
    mediumUrl: "https://samueladesola.medium.com/how-to-control-the-p1-and-p0-port-pins-of-arduino-nano-33-ble-sense-86d0b7002b97",
    tags: ["IoT", "Arduino", "GPIO", "Electronics", "TinyML"],
    coverImage: "https://cdn-images-1.medium.com/max/742/1*uyHLPWf1oK_rfHNydGEL0g.png",
  },
  {
    id: 7,
    title: "Setting up Arduino Clone on Ubuntu Linux",
    excerpt: "I was trying to build a robot car with ROS2 and needed a motor controller. I chose an Arduino Uno SMD clone, but it wouldn't work on Linux. Here's the surprisingly simple fix.",
    date: "May 18, 2024",
    readTime: "3 min read",
    mediumUrl: "https://samueladesola.medium.com/setting-up-arduino-clone-on-ubuntu-linux-bca3feb061b1",
    tags: ["Ubuntu", "Linux", "Electronics", "Clones", "Arduino"],
    coverImage: "https://cdn-images-1.medium.com/max/1024/1*VCZxyJ8CutS7OWFh0eiVhw.jpeg",
  },
  {
    id: 8,
    title: "How to set up ESP32-WROOM-32",
    excerpt: "A quick guide on how to set up the ESP32-WROOM-32 board. We will set up the Arduino IDE, get the board installed, get the driver installed, and test it out.",
    date: "December 16, 2023",
    readTime: "6 min read",
    mediumUrl: "https://samueladesola.medium.com/how-to-set-up-esp32-wroom-32-b2100060470c",
    tags: ["RTOS", "Embedded Systems", "Arduino", "FreeRTOS", "ESP32"],
    coverImage: "https://cdn-images-1.medium.com/max/1024/1*nkTIzfJBRJLHK5U0FrXk8Q.jpeg",
  },
  {
    id: 9,
    title: "To Learn is to Know: Getting Started with Embedded Systems",
    excerpt: "Among various fields in tech, embedded systems have always been a bone of contention, especially for beginners. With proper planning and information, getting started will be as seamless as possible.",
    date: "August 1, 2023",
    readTime: "8 min read",
    mediumUrl: "https://samueladesola.medium.com/to-learn-is-to-know-getting-started-with-embedded-sytems-1d2127ad7839",
    tags: ["Getting Started", "Embedded Systems", "Tech"],
    coverImage: "https://cdn-images-1.medium.com/max/1024/0*4OWaBf9On8c-oybn",
  },
  {
    id: 10,
    title: "Design Thinking in Embedded Systems",
    excerpt: "One will surely be surprised when the topic of design thinking is raised in an Embedded Systems class. What differentiates the expert from the newcomers? It's the design thought that birthed the system.",
    date: "July 22, 2023",
    readTime: "6 min read",
    mediumUrl: "https://samueladesola.medium.com/design-thinking-in-embedded-systems-5821dc8625fa",
    tags: ["Embedded Systems", "Machine Learning", "IoT", "Hardware"],
    coverImage: "https://cdn-images-1.medium.com/max/1024/0*Fj7X3eNq-b7KJGN7",
  },
  {
    id: 11,
    title: "How to send DHT data from Raspberry Pi to IBM cloud",
    excerpt: "Detailed explanation on how to send DHT 11 data from Raspberry Pi to IBM Cloud Watson IoT Platform. In this tutorial, I will be taking you through steps in sending data from Raspberry Pi to the IBM Cloud IoT platform.",
    date: "June 17, 2022",
    readTime: "10 min read",
    mediumUrl: "https://samueladesola.medium.com/how-to-send-dht-data-from-raspberry-pi-to-ibm-cloud-3c748e4dea63",
    tags: ["DHT11", "IBM Watson", "IBM Cloud", "Raspberry Pi", "IoT"],
    coverImage: "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*63K2yXhadSFYEqXN",
  },
  {
    id: 12,
    title: "How to send data from ESP8266 to Qubitro using DHT11",
    excerpt: "IoT being an integral part of cloud computing, several cloud vendors make IoT part of the services they render. In this tutorial, I will be taking you through the steps in sending data from ESP8266 to the Qubitro IoT platform using the MQTT protocol.",
    date: "May 21, 2022",
    readTime: "7 min read",
    mediumUrl: "https://samueladesola.medium.com/how-to-send-data-from-esp8266-to-qubitro-using-dht11-e91fbc7b01a8",
    tags: ["IoT", "Qubitro", "DHT11", "Internet Of Things", "Weather Station"],
    coverImage: "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*l2rSHEnD_KUFJccQ.png",
  },
  {
    id: 13,
    title: "How to send DHT data from ESP8266 to Arduino IoT Cloud",
    excerpt: "In this tutorial, I will be taking you through the steps in sending data from NodeMCU, an IoT development platform to Arduino Cloud. We will be using DHT 11 sensor to send Temperature and Humidity data to Arduino Cloud.",
    date: "April 2, 2022",
    readTime: "7 min read",
    mediumUrl: "https://samueladesola.medium.com/how-to-send-dht-data-from-esp8266-to-arduino-iot-cloud-de50af5ea325",
    tags: ["ESP8266", "Arduino", "DHT", "Cloud", "Arduino Cloud"],
    coverImage: "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*Kpxi_OUI58fLvDOG.png",
  },
  {
    id: 14,
    title: "How to send DHT data from ESP8266 to Google Firebase",
    excerpt: "In this tutorial, I will be taking you through the steps in sending data from NodeMCU, an IoT development platform to Google Firebase. We will be using DHT 11 sensor to send Temperature and Humidity data to Firebase Realtime Database.",
    date: "April 2, 2022",
    readTime: "6 min read",
    mediumUrl: "https://samueladesola.medium.com/how-to-send-dht-data-from-esp8266-to-google-firebase-d733e20e1e95",
    tags: ["Firebase", "ESP8266 NodeMCU", "DHT11", "IoT", "How To"],
    coverImage: "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*1rj6tfuFZz_HWobg.png",
  },
  {
    id: 15,
    title: "How to send data to Azure IoT Central using NodeMCU",
    excerpt: "In this tutorial, I will be taking you through steps in sending data from NodeMCU, an IoT development platform to Azure IoT Central. We will be using DHT 11 sensor to send Temperature and Humidity data to Azure IoT Central.",
    date: "January 1, 2022",
    readTime: "6 min read",
    mediumUrl: "https://samueladesola.medium.com/how-to-send-data-to-azure-iot-central-using-nodemcu-25c48d2e2f6c",
    tags: ["Azure IoT Central", "DHT", "NodeMCU", "Data", "IoT"],
    coverImage: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*IuhwYNkNriyTIRrSgyI3kw.jpeg",
  },
  {
    id: 16,
    title: "Connecting your Cellphone to Microsoft Azure IoT Central",
    excerpt: "The term 'Internet of Things' simply involves the integration of things to the internet. Today, I will be giving a detailed guide on how to connect your IoT device to the Microsoft Azure IoT platform, a service offered by Microsoft Azure cloud services.",
    date: "December 29, 2021",
    readTime: "5 min read",
    mediumUrl: "https://samueladesola.medium.com/connecting-your-cellphone-to-microsoft-azure-iot-central-a956d76768bf",
    tags: ["Connect", "Azure", "Azure IoT Central", "Mobile Phone", "Cellphone"],
    coverImage: "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*TzHwNJk8p4ktCvl3",
  },
  {
    id: 17,
    title: "IoT in Africa: The Kenya Animals, The Poachers, and IoT",
    excerpt: "There are over one million species of animals in Africa. Combating wildlife poaching and trafficking with IoT has brought about a great reduction in poaching. One implementation of IoT in preserving wildlife in Kenya is 'Smart', a spatial monitoring and reporting tool.",
    date: "October 27, 2021",
    readTime: "3 min read",
    mediumUrl: "https://samueladesola.medium.com/iot-in-africa-the-kenya-animals-the-poachers-and-iot-3487f824484a",
    tags: ["IoT", "Africa", "Kenya", "Poachers"],
    coverImage: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*kAmSzWmvoqsEhRVm9wUo_g.jpeg",
  },
  {
    id: 18,
    title: "IoT in Africa: Where are we coming from? Where are we, and where we are going?",
    excerpt: "The present and the future industrial revolution will be characterized by new technologies ranging from Artificial Intelligence, Machine Learning, and the Internet of Things (IoT). For a place like Africa, IoT can still be seen as an emerging technology because its power has not been fully tapped into.",
    date: "October 25, 2021",
    readTime: "2 min read",
    mediumUrl: "https://samueladesola.medium.com/iot-in-africa-where-are-we-coming-from-where-are-we-and-where-we-are-going-978ffa27ac9b",
    tags: ["IoT", "Africa"],
    coverImage: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*H19jTkQsbuPliHuVDb0dpg.png",
  },
];
